"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeAppProvider = void 0;
var provider_1 = require("./provider");
Object.defineProperty(exports, "SafeAppProvider", { enumerable: true, get: function () { return provider_1.SafeAppProvider; } });
//# sourceMappingURL=index.js.map